"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doLogin = exports.notLoginLink = void 0;
var ezbuyAppUtil_1 = require("./ezbuyAppUtil");
var link_1 = require("./link");
exports.notLoginLink = function (ret) {
    return "/login" + (typeof ret === "undefined" ? "" : "?ret=" + encodeURIComponent(ret));
};
exports.doLogin = function (ret) {
    if (ezbuyAppUtil_1.isFromEzbuyapp() || ezbuyAppUtil_1.isFromEzbuyint()) {
        link_1.login();
    }
    else {
        location.href = exports.notLoginLink(ret);
    }
};
